var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 51,
    viewBox: "0 0 234 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 142.486,
    width: 5.65217,
    height: 81.4855,
    transform: "rotate(90 142.486 0)",
    fill: "#BAE3F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 23,
    width: 5.00001,
    height: 186,
    transform: "rotate(90 186 23)",
    fill: "#BAE3F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 45.2174,
    width: 5.65217,
    height: 173,
    transform: "rotate(90 234 45.2174)",
    fill: "#BAE3F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.7a315075930263c282635d9052e185a1.svg";
export { ForwardRef as ReactComponent };